import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// BURADAKİ BİLGİLER SENİN KENDİ FIREBASE PANELİNDEN ALDIĞIN BİLGİLER OLMALI
const firebaseConfig = {
  apiKey: "AIzaSyCabC1jqK-Z7dU6gbJ647Gyu1lRXY8JRnw",
  authDomain: "ags-lms.firebaseapp.com",
  projectId: "ags-lms",
  storageBucket: "ags-lms.appspot.com",
  messagingSenderId: "SENDER_ID",
  appId: "APP_ID"
};

// Uygulamayı başlat
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);